import React from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { Redirect } from "react-router-dom";
import StatEngineTable from "./StatEngineTable";
import { isToolSub } from "../../../../../../AuthUtils";

const GET_STATS = graphql`
  query NFLStatEngineQuery(
    $startWeek: Int
    $endWeek: Int
    $count: Int
    $cursor: String
    $positions: [String]
    $sortBy: NFLStatSortByInput
    $weeks: [Int]
    $seasonID: ID
  ) {
    whoAmI {
      groups {
        name
      }
    }

    ...StatEngineTable_query
      @arguments(
        startWeek: $startWeek
        endWeek: $endWeek
        count: $count
        cursor: $cursor
        positions: $positions
        sortBy: $sortBy
        weeks: $weeks
        seasonID: $seasonID
      )
  }
`;

export default function NFLStatEngine({
  variables,
  fetchKey,
  positions,
  teamIds,
  teams,
  onRowCount,
  emptyState,
}) {
  const data = useLazyLoadQuery(
    GET_STATS,
    {
      count: 10000,
      startWeek: 1,
      endWeek: 17,
      weeks: variables.weeks,
      seasonID: variables.seasonID,
    },
    { fetchKey, fetchPolicy: fetchKey > 0 ? "network-only" : "store-or-network" }
  );

  if (!data.whoAmI || !isToolSub(data.whoAmI.groups)) {
    return <Redirect to="/memberships" />;
  }

  return (
    <StatEngineTable
      query={data}
      positions={positions}
      teamIds={teamIds}
      teams={teams}
      onRowCount={onRowCount}
      emptyState={emptyState}
    />
  );
}
